module.exports = __webpack_public_path__ + "static/img/img9.82ec633.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/img9.jpg
// module id = BhiK
// module chunks = 1